import React from 'react';
import { Icon } from '@adobe/react-spectrum';

const HomeIcon = props => {
  return (
    <Icon {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
      >
        <path
          d="M17.1309 5.73438L11.3809 1.26172C10.5684 0.63086 9.43164 0.62988 8.61914 1.2627L2.86914 5.73438C2.32519 6.15723 2 6.82129 2 7.51075V15.75C2 16.9902 3.00977 18 4.25 18H15.75C16.9902 18 18 16.9902 18 15.75V7.51074C18 6.82129 17.6758 6.15723 17.1309 5.73438ZM11.5 16.5H8.5V11.75C8.5 11.3369 8.83691 11 9.25 11H10.75C11.1631 11 11.5 11.3369 11.5 11.75V16.5ZM16.5 15.75C16.5 16.1631 16.1631 16.5 15.75 16.5H13V11.75C13 10.5098 11.9902 9.5 10.75 9.5H9.25C8.00977 9.5 7 10.5098 7 11.75V16.5H4.25C3.83691 16.5 3.5 16.1631 3.5 15.75V7.51074C3.5 7.28125 3.6084 7.05957 3.78906 6.91797L9.53906 2.44727C9.81152 2.23536 10.1904 2.23829 10.4609 2.44629L16.21 6.91797C16.3916 7.05957 16.5 7.28125 16.5 7.51074V15.75Z"
          fill="#222222"
        />
      </svg>
    </Icon>
  );
};

export default HomeIcon;
